<script>
    import { knuthShuffle } from 'knuth-shuffle';

    import { gameStarted, timerSeconds, paused, randomizedCountries, countriesLoaded, country, score } from '../stores.js';
    import { countries } from '../laender.json';

    function toggleGameState() {
        if ($gameStarted) {
            timerSeconds.set(300);
            paused.set(false);
            gameStarted.set(false);
        } else {
            // just 9 flags not all :) 27 Apr 2021 gurugeek
            timerSeconds.set(300);

            
            const shuffled = knuthShuffle(Object.keys(countries)).slice(1,6);
            randomizedCountries.set(shuffled);
            country.set(countries[$randomizedCountries[0]]);
       
            score.set(0);
            gameStarted.set(true);
            
            console.log(shuffled);
        }
    }
</script>


<button class="mui-btn mui-btn--primary mui-btn--raised" on:click={toggleGameState}>{$gameStarted ? 'Restart' : 'Start'}</button>